import { render } from "./planet.vue?vue&type=template&id=cc5bbeb8&scoped=true"
import script from "./planet.vue?vue&type=script&lang=js"
export * from "./planet.vue?vue&type=script&lang=js"

import "./planet.vue?vue&type=style&index=0&id=cc5bbeb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5bbeb8"]])

export default __exports__